import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/c803e29a-a90d-4012-8857-5f6ff72d0d70";
export const REGISTER_URL = "https://a.ntrk2.com/0428ef34-b0ae-4b66-a09d-36ff42a99834";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://wowplayph.load2app.com/download?openExternalBrowser=1&id=cuy456hicqyw78x";

export * from "./codes";
export * from "./context";
